import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ProductOrderBy } from '../../../services/apis/product-api.service';

interface Option {
  value: string;
  name: string;
}
@Component({
  selector: 'app-product-order-by-select',
  imports: [MatSelectModule, FormsModule],
  templateUrl: './product-order-by-select.html',
  styleUrl: './product-order-by-select.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductOrderBySelect),
      multi: true,
    },
  ],
})
export class ProductOrderBySelect implements ControlValueAccessor {
  options: Option[] = [
    {
      value: ProductOrderBy.RECOMMENDED,
      name: 'Recommended',
    },
    {
      value: ProductOrderBy.CREATED_AT,
      name: 'Newest',
    },
    {
      value: ProductOrderBy.PRICE_ASC,
      name: 'Price: Low to High',
    },
    {
      value: ProductOrderBy.PRICE_DESC,
      name: 'Price: High to Low',
    },
  ];
  value: ProductOrderBy = ProductOrderBy.RECOMMENDED;

  onValueChanged() {
    this.onChange(this.value);
  }

  onChange: (value: ProductOrderBy) => void = () => {};
  onTouched: () => void = () => {};
  writeValue(value?: ProductOrderBy): void {
    this.value = value || ProductOrderBy.RECOMMENDED;
  }

  registerOnChange(fn: (value: ProductOrderBy) => void): void {
    this.onChange = fn; // 注册外部的变更回调
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn; // 注册外部的触摸回调
  }

  disabled: boolean = false;
  // 可选：禁用组件
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
